import React from "react";
// import { useContext } from "react";
import { useState } from "react";
// import StoreContext from "../../Store/code-context";
import classes from "./ProjectForm.module.css";

export default function ProjectForm(props) {
  // const storeCtx = useContext(StoreContext);

  const [projectName, setProjectName] = useState("");
  const changeHandler = (event) => setProjectName(event.target.value);
  const submitHandler = (event) => {
    event.preventDefault();
    if (projectName.length === 0) return;

    props.onSubmitForm(projectName);
    // storeCtx.IsFile((prev) => !prev);
    setProjectName("");
  };
  return (
    <form onSubmit={submitHandler} className={classes.form}>
      <label>Enter Project Name </label>
      <input type="text" value={projectName} onChange={changeHandler} />
      <button type="submit">Create Project</button>
    </form>
  );
}
